import type { languages } from 'monaco-editor';

/**
 * Monarch tokenizer для JSON.
 *
 * Monaco Editor не включает JSON в basic-languages (Monarch tokenizers).
 * JSON обрабатывается через полноценный language service (vs/language/json),
 * который требует Web Worker для работы.
 *
 * При использовании `monaco.editor.colorize()` (статическая подсветка без создания
 * editor instance), JSON worker не инициализируется, и подсветка не работает.
 *
 * Этот Monarch tokenizer позволяет подсвечивать JSON без worker'а.
 */
export const jsonMonarchLanguage: languages.IMonarchLanguage = {
	tokenPostfix: '.json',

	keywords: ['true', 'false', 'null'],

	tokenizer: {
		root: [
			// whitespace
			[/\s+/, ''],

			// numbers
			[/-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/, 'number'],

			// strings
			[/"(?:[^"\\]|\\.)*"(?=\s*:)/, 'string.key.json'],
			[/"(?:[^"\\]|\\.)*"/, 'string.value.json'],

			// keywords
			[/(?:true|false|null)\b/, 'keyword'],

			// delimiters
			[/[{}[\]]/, '@brackets'],
			[/[,:]/, 'delimiter'],
		],
	},
};
